<template>
  <div class="cp-set-website main">
    <div class="divider" />
    <div class="row">
      <p><i class="fa fa-globe icon" />Website</p>
      <div style="margin-top: 10px">
        <textarea
          class="textarea"
          v-model="website"
          placeholder="www.your-shop.com"
          rows="2"
        />
      </div>
      <div class="save-wrapper">
        <p v-if="updatingWebsite" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveWebsite">Save</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetWebsite",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      website: null,
      updatingWebsite: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
  },
  mounted() {
    this.website = this.business.data.website;
  },
  methods: {
    saveWebsite() {
      if (!this.website || this.website.length < 5) {
        var msg = "Enter a valid website";
        this.errorToast(msg);
        return;
      }
      this.updatingWebsite = true;
      var obj = { website: this.website };
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated website");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingWebsite = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
</style>
